/**
 * Creates an HTML5 Video Element
 * @class directive_v3sVideo
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').directive('v3sVideo', ["v3sMediaService", "v3sContentMediaPath", "v3sContentConfig", function (v3sMediaService, v3sContentMediaPath, v3sContentConfig) {
    return {
        restrict: 'E',
        require : '^v3sDocument',
        scope: {
            id: '@',
            v3sFile: '@',
            v3sPoster: '@',
            v3sWidth: '@',
            v3sHeight: '@'
        },
        link: function (scope, element, attrs, docCtrl, transclude) {
            if (!!scope.id) {
                docCtrl.addElement(element);

                var video = {
                    id: scope.id,
                    video: element,
                    file: scope.v3sFile,
                    subtitle: ""
                }

                var subtitle = element.find("v3s-audiotext");

                var thumbnail = element.find("v3s-thumbnail");
                thumbnail = thumbnail.length > 0 ? thumbnail : false;

                if (subtitle.length > 0) {
                    var videotxt = angular.element("<v3s-videotext></v3s-videotext>");
                    videotxt.append(subtitle);
                    element.parent().append(videotxt);
                    video.subtitle = subtitle.text();
                }

                if (!!scope.v3sPoster) {
                    element.css('background-image', 'url(' + v3sContentMediaPath + scope.v3sPoster + ')');
                }

                //element.empty();

                angular.forEach(element.children(), function (child) {
                    if (child.tagName.toLowerCase() != "v3s-thumbnail") {
                        child.parentNode.removeChild(child);
                    }
                })

                if (thumbnail) {
                    var showThumbnailOnMobile = (thumbnail.attr('v3s-mobile') == "true");
                    var showThumbnailOnDesktop = (thumbnail.attr('v3s-desktop') == "true");
                    if(!showThumbnailOnDesktop && showThumbnailOnMobile){
                        element.addClass("only-mobile-thumbnail");
                    } else if(showThumbnailOnDesktop && !showThumbnailOnMobile) {
                        if (v3sContentConfig.responsive) {
                            element.addClass("only-desktop-thumbnail");
                        } else {
                            element.addClass("only-thumbnail");
                        }
                    } else if (showThumbnailOnDesktop && showThumbnailOnMobile) {
                        element.addClass("only-thumbnail");
                    }
                }

                //für Smartphones, damit Größenverhältnis korrekt bleibt
                var canvas = document.createElement('canvas');
                canvas.setAttribute('width', scope.v3sWidth);
                canvas.setAttribute('height', scope.v3sHeight);
                var ctx = canvas.getContext('2d');
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                var src = canvas.toDataURL('image/png');
                var img = new Image();
                img.src = src;

                element.append(angular.element(img));

                v3sMediaService.createMedia(video);


                element.bind("dblclick", function (evt) {
                    var vidElement = element[0].querySelector("video");
                    if (!vidElement) return;
                    var fullScreenFunction = vidElement.requestFullscreen || vidElement.webkitRequestFullscreen || vidElement.mozRequestFullScreen || vidElement.msRequestFullscreen;
                    if (fullScreenFunction) {
                        fullScreenFunction.call(vidElement);
                    }
                })

                element.bind("contextmenu", function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                })
            }
        }
    }
}]);
